export function resolveStorefrontPath(
  value: string | null | undefined
): string {
  const slug = value?.trim().replace(/^\/|\/$/g, '');

  return slug && !/[/?#\\\s]/u.test(slug) ? `/${slug}` : '/';
}
